import {
    DOWNLOAD_SETTLEMENT_CSV,
    DOWNLOAD_SETTLEMENT_CSV_FAILURE,
    DOWNLOAD_SETTLEMENT_CSV_SUCCESS,
    GET_ALL_PAYOUTS,
    GET_SETLLEMENTS_ANALYTICS,
    GET_SETLLEMENTS_ANALYTICS_FAILURE,
    GET_SETTLEMENTS_ANALYTICS_SUCCESS,
    GET_SETTLEMENT_TRANSACTION,
    GET_SETTLEMENT_TRANSACTION_FAILURE,
    GET_SETTLEMENT_TRANSACTION_SUCCESS,
    GET_SINGLE_PAYOUTS,
    GET_UNSETTLED_SETTLEMENTS,
    GET_UNSETTLED_SETTLEMENTS_FAILURE,
    GET_UNSETTLED_SETTLEMENTS_SUCCESS,
    SET_ALL_PAYOUTS,
    SET_SINGLE_PAYOUTS
} from './actionTypes';

export const getAllPayouts = data => {
    return {
        payload: data,
        type: GET_ALL_PAYOUTS
    };
};

export const setAllPayouts = data => {
    return {
        payload: data,
        type: SET_ALL_PAYOUTS
    };
};

export const getSinglePayouts = data => {
    return {
        payload: data,
        type: GET_SINGLE_PAYOUTS
    };
};

export const setSinglePayouts = data => {
    return {
        payload: data,
        type: SET_SINGLE_PAYOUTS
    };
};

export const getSettlementsTransaction = data => {
    return {
        payload: data,
        type: GET_SETTLEMENT_TRANSACTION
    };
};

export const setSettlementsTransactionSuccess = data => {
    return {
        payload: data,
        type: GET_SETTLEMENT_TRANSACTION_SUCCESS
    };
};

export const setSettlementsTransactionFailure = data => {
    return {
        payload: data,
        type: GET_SETTLEMENT_TRANSACTION_FAILURE
    };
};

export const getUnsettledSettlements = data => {
    return {
        payload: data,
        type: GET_UNSETTLED_SETTLEMENTS
    };
};

export const getUnsettledSettlementsFailure = data => {
    return {
        payload: data,
        type: GET_UNSETTLED_SETTLEMENTS_FAILURE
    };
};

export const getUnsettledSettlementsSuccess = data => {
    return {
        payload: data,
        type: GET_UNSETTLED_SETTLEMENTS_SUCCESS
    };
};

export const getSettlementsAnaltics = data => {
    return {
        payload: data,
        type: GET_SETLLEMENTS_ANALYTICS
    };
};

export const getSettlementsAnalyticsFailure = data => {
    return {
        payload: data,
        type: GET_SETLLEMENTS_ANALYTICS_FAILURE
    };
};

export const getSettlementsAnalyticsSuccess = data => {
    return {
        payload: data,
        type: GET_SETTLEMENTS_ANALYTICS_SUCCESS
    };
};

export const getSettlementsCsv = data => {
    return {
        payload: data,
        type: DOWNLOAD_SETTLEMENT_CSV
    };
};

export const getSettlementsCsvFailure = data => {
    return {
        payload: data,
        type: DOWNLOAD_SETTLEMENT_CSV_FAILURE
    };
};

export const getSettlementsCsvSuccess = data => {
    return {
        payload: data,
        type: DOWNLOAD_SETTLEMENT_CSV_SUCCESS
    };
};
